export const actionTypes = {
  SEND_CSV_REQUEST: "SEND_CSV_REQUEST",
  SEND_CSV_REQUEST_SUCCESS: "SEND_CSV_REQUEST_SUCCESS",
  SEND_CSV_REQUEST_FAILURE: "SEND_CSV_REQUEST_FAILURE",
};

export const sendCsvAction = (payload: {
  type: "secondaryOus" | "secondaryManagers";
  body: any;
}) => ({ type: actionTypes.SEND_CSV_REQUEST, payload });

export const sendCsvActionSuccess = (payload: any) => ({
  type: actionTypes.SEND_CSV_REQUEST_SUCCESS,
  payload,
});

export const sendCsvActionFailure = (error: any) => ({
  type: actionTypes.SEND_CSV_REQUEST_FAILURE,
  error,
});
